import { useState, type ReactNode } from "react";
import Button from "../../ui/Button/Button";
import PasswordField from "../../ui/PasswordField/PasswordField";
import type { LoginRequestDto } from "../../../types/types";

export type LoginFormProps = {
  onSubmit: (payload: LoginRequestDto) => void | Promise<void>;
  isSubmitting?: boolean;
  errorMessage?: string | null;
  submitLabel?: string;
  defaultEmail?: string;
  footer?: ReactNode;
};

const LoginForm = ({
  onSubmit,
  isSubmitting = false,
  errorMessage = null,
  submitLabel = "Log in",
  defaultEmail = "",
  footer,
}: LoginFormProps) => {
  const [email, setEmail] = useState(defaultEmail);
  const [password, setPassword] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await onSubmit({
      email: email.trim(),
      password,
    });
  };

  return (
    <form onSubmit={(event) => void handleSubmit(event)} className="space-y-4 rounded-xl border border-myteengig-border bg-white p-6 shadow-sm">
      <div>
        <label htmlFor="login-email" className="mb-1 block text-sm font-medium text-myteengig-text-primary">
          Email
        </label>
        <input
          id="login-email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          className="w-full rounded-md border border-myteengig-border bg-white px-3 py-2 text-sm text-myteengig-text-primary outline-none focus:border-myteengig-primary"
          placeholder="you@example.com"
        />
      </div>

      <div>
        <label htmlFor="login-password" className="mb-1 block text-sm font-medium text-myteengig-text-primary">
          Password
        </label>
        <PasswordField
          id="login-password"
          autoComplete="current-password"
          required
          minLength={8}
          maxLength={72}
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          className="w-full rounded-md border border-myteengig-border bg-white px-3 py-2 text-sm text-myteengig-text-primary outline-none focus:border-myteengig-primary"
          placeholder="Enter your password"
        />
      </div>

      {errorMessage ? (
        <p role="alert" className="text-sm text-red-700">
          {errorMessage}
        </p>
      ) : null}

      <Button type="submit" variant="primary" className="w-full" disabled={isSubmitting}>
        {isSubmitting ? "Logging in..." : submitLabel}
      </Button>

      {footer ? <div className="border-t border-myteengig-border pt-4">{footer}</div> : null}
    </form>
  );
};

export default LoginForm;
